export default function Loader(): JSX.Element {
  return (
    <main className="page-body__page-main">
      <section className="page-body__container">
        <h2 className="visually-hidden">Загрузка информации</h2>

        <p className="main-events__msg">Загрузка...</p>
      </section>
    </main>
  );
}
